export const GTM_EVENTS = {
  FORTELLIS_EVENT: 'fortellis-event',
  MARKETPLACE_FILTER_CHANGED: 'Marketplace Filter Changed'
};

/**
 * Extracts normalized active filters arrays from the checkedFilters state object.
 */
export const getActiveFiltersFromChecked = (checkedFilters = {}) => {
  const active = {
    categories: [],
    industries: [],
    publishers: [],
    integrations: [],
    discover_by: []
  };

  if (!checkedFilters || typeof checkedFilters !== 'object') {
    return active;
  }

  // Categories
  if (checkedFilters['Categories']) {
    Object.entries(checkedFilters['Categories']).forEach(([key, val]) => {
      if (val && val !== false) {
        active.categories.push(val.name || key);
      }
    });
  }

  // Industry
  if (checkedFilters['Industry']) {
    Object.entries(checkedFilters['Industry']).forEach(([key, val]) => {
      if (val && val !== false) {
        active.industries.push(val.name || key);
      }
    });
  }

  // Publishers
  if (checkedFilters['Publishers']) {
    Object.entries(checkedFilters['Publishers']).forEach(([key, val]) => {
      if (val && val !== false) {
        active.publishers.push(val.name || key);
      }
    });
  }

  // Integrations
  if (checkedFilters['Integrations']) {
    Object.entries(checkedFilters['Integrations']).forEach(([key, val]) => {
      if (val && val !== false) {
        active.integrations.push(val.name || key);
      }
    });
  }

  // Discover by
  if (checkedFilters['Discover by']) {
    Object.entries(checkedFilters['Discover by']).forEach(([key, val]) => {
      if (val && val !== false) {
        active.discover_by.push(val.name || key);
      }
    });
  }

  return active;
};

/**
 * Tracks marketplace filter changed event and pushes payload to window.dataLayer.
 */
export const trackMarketplaceFilterChanged = ({
  filterType,
  filterValue,
  action,
  checkedFilters = {},
  resultsCount = 0
}) => {
  const activeFilters = getActiveFiltersFromChecked(checkedFilters);
  const totalActiveFilters =
    activeFilters.categories.length +
    activeFilters.industries.length +
    activeFilters.publishers.length +
    activeFilters.integrations.length +
    activeFilters.discover_by.length;

  const payload = {
    event: GTM_EVENTS.FORTELLIS_EVENT,
    event_action: GTM_EVENTS.MARKETPLACE_FILTER_CHANGED,
    filter_type: filterType || '',
    filter_value: filterValue != null ? String(filterValue) : '',
    action: action || 'added',
    active_filters: activeFilters,
    total_active_filters: totalActiveFilters,
    results_count: resultsCount != null ? Number(resultsCount) : 0
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
  return payload;
};
